import { PageInfoDto } from '@/dto';
import { FIELDS } from './constants';

export let ShippingMethod = [
      FIELDS.ID,
    FIELDS.SHIPPING_PROVIDER_ID,
    FIELDS.NAME,
    FIELDS.SHIPPING_DAYS,
    FIELDS.SHIPPING_ACCOUNT,
    FIELDS.Q_BSYNCED,
    FIELDS.Q_BSHIP_VIA_NAME,
    FIELDS.Q_BSHIP_VIA_LIST_ID,
    FIELDS.ACTIVE,

];

export let ShippingMethodView = [
      FIELDS.ID,
    FIELDS.SHIPPING_PROVIDER_ID,
    FIELDS.SHIPPING_PROVIDER_NAME,
    FIELDS.NAME,
    FIELDS.SHIPPING_DAYS,
    FIELDS.SHIPPING_ACCOUNT,
    FIELDS.CREATED_BY_USER_ID,
    FIELDS.CREATED_BY_USER_FULL_NAME,
    FIELDS.MODIFIED_BY_USER_ID,
    FIELDS.MODIFIED_BY_USER_FULL_NAME,
    FIELDS.DATE_CREATED,
    FIELDS.DATE_MODIFIED,
    FIELDS.ACTIVE,

];

export class ShippingMethodListDto {
  constructor(results) {
    this.items = results.items.map(item => new gridDto(item));
    this.pageInfo = new PageInfoDto(results.paging);
  }
}

export class ShippingMethodDto {
  constructor(data = {}) {
    ShippingMethod.forEach(key => (this[key] = data[key] || null));
  }
}

export class gridDto {
  constructor(data = {}) {
    ShippingMethodView.forEach(key => (this[key] = data[key] || null));
  }
}
